import type { PublicRuntimeConfig } from 'nuxt/schema'
import type {
  User,
} from 'oidc-client-ts'
import type { PrivacySettings, UserGrant } from './types'
import {
  UserManager,
  WebStorageStateStore,
} from 'oidc-client-ts'

export const UserSymbol: InjectionKey<Ref<User | undefined>> = Symbol('user')
export const UserPermissionSymbol: InjectionKey<Ref<string[]>> = Symbol('permissions')
export const PrivacySettingsSymbol: InjectionKey<Ref<PrivacySettings | undefined>> = Symbol('privacysettings')
export const UserManagerSymbol: InjectionKey<Ref<UserManager | undefined>> = Symbol('usermanager')
export const UserGrantSymbol: InjectionKey<Ref<UserGrant[] | undefined>> = Symbol('usergrant')
export const ProjectGrantSymbol: InjectionKey<Ref<string[] | undefined>> = Symbol('projectGrant')

const scopes = [
  'openid',
  'profile',
  'email',
  'urn:zitadel:iam:org:project:id:zitadel:aud',
  'urn:zitadel:iam:user:resourceowner',
  'urn:zitadel:iam:org:project:role:read',
  'urn:zitadel:iam:org:project:role:write',
  'urn:zitadel:iam:org:project:role:manage',
  'urn:zitadel:iam:user:metadata',
]

export function createAuth(config: PublicRuntimeConfig, client: string): UserManager {
  return new UserManager({
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    authority: `${config.authority}`,
    client_id: client,
    redirect_uri: `${config.redirect_uri}`,
    response_type: 'code',
    scope: scopes.join(' '),
    post_logout_redirect_uri: config.redirect_uri_logout,
    response_mode: 'query',
    loadUserInfo: true,
  })
}
